import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link as ScrollLink } from "react-scroll";
import { Link as RouterLink, useLocation } from "react-router-dom";
// Components
import Sidebar from "../Nav/Sidebar";
import Backdrop from "../Elements/Backdrop";
// Assets
import BurgerIcon from "../../assets/svg/BurgerIcon";

const NAV_ITEMS = [
  { to: "home", label: "Home" },
  { to: "wings", label: "Our Wings" },
  { to: "projects", label: "Success Stories" },
  { to: "blog", label: "Blog" },
  { to: "reviews", label: "Reviews" },
  { to: "contact", label: "Contact" },
];

export default function TopNavbar() {
  const [y, setY] = useState(typeof window !== "undefined" ? window.scrollY : 0);
  const [sidebarOpen, toggleSidebar] = useState(false);
  const location = useLocation();
  const isLanding = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setY(window.scrollY);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const linkStyle = { padding: "10px 15px" };
  const scrollProps = { activeClass: "active", className: "whiteColor", style: linkStyle, spy: true, smooth: true, offset: -80 };

  return (
    <>
      <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      {sidebarOpen && <Backdrop toggleSidebar={toggleSidebar} />}
      <Wrapper className="flexCenter animate" style={y > 100 ? { height: "60px" } : { height: "80px" }}>
        <NavInner className="container flexSpaceCenter">
          {isLanding ? (
            <ScrollLink className="pointer flexNullCenter" to="home" smooth={true}>
              <LogoImage src="/logo.png" alt="AFRIQ Logo" />
              <h1 style={{ marginLeft: "15px" }} className="font20 extraBold whiteColor">
                AFRIQ
              </h1>
            </ScrollLink>
          ) : (
            <RouterLink className="pointer flexNullCenter" to="/" style={{ textDecoration: "none" }}>
              <LogoImage src="/logo.png" alt="AFRIQ Logo" />
              <h1 style={{ marginLeft: "15px" }} className="font20 extraBold whiteColor">
                AFRIQ
              </h1>
            </RouterLink>
          )}
          <BurderWrapper className="pointer" onClick={() => toggleSidebar(!sidebarOpen)}>
            <BurgerIcon />
          </BurderWrapper>
          <UlWrapper className="flexNullCenter">
            {NAV_ITEMS.map(({ to, label }) => (
              <li key={to} className="semiBold font15 pointer">
                {isLanding ? (
                  <ScrollLink {...scrollProps} to={to}>
                    {label}
                  </ScrollLink>
                ) : (
                  <RouterLink className="whiteColor" style={linkStyle} to={`/#${to}`}>
                    {label}
                  </RouterLink>
                )}
              </li>
            ))}
          </UlWrapper>
          <UlWrapperRight className="flexNullCenter">
            <li className="semiBold font15 pointer">
              <RouterLink to="/tutor-apply" style={{ padding: "10px 30px 10px 0" }} className="whiteColor">
                Join AFRIQ as a Tutor
              </RouterLink>
            </li>
            <li className="semiBold font15 pointer flexCenter">
              <RouterLink to="/apply" className="radius8 whiteBg" style={{ padding: "10px 15px", color: "#4b2e83", fontWeight: "600" }}>
                Apply now
              </RouterLink>
            </li>
          </UlWrapperRight>
        </NavInner>
      </Wrapper>
    </>
  );
}

const Wrapper = styled.nav`
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  background: rgba(75, 46, 131, 0.95);
  backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  
  &:hover {
    background: rgba(75, 46, 131, 0.98);
    box-shadow: 0 6px 25px rgba(0, 0, 0, 0.15);
  }
`;
const NavInner = styled.div`
  position: relative;
  height: 100%;
`
const BurderWrapper = styled.button`
  outline: none;
  border: 0px;
  background-color: transparent;
  height: 100%;
  padding: 0 20px;
  min-width: 44px;
  min-height: 44px;
  display: none;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:active {
    background: rgba(255, 255, 255, 0.1);
  }
  
  @media (max-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
const UlWrapper = styled.ul`
  display: flex;
  gap: 5px;
  
  @media (max-width: 768px) {
    display: none;
  }
`;

const UlWrapperRight = styled.ul`
  display: flex;
  align-items: center;
  gap: 15px;
  
  @media (max-width: 768px) {
    display: none;
  }
`;

const LogoImage = styled.img`
  width: 40px;
  height: 40px;
  object-fit: contain;
  transition: all 0.3s ease;
  
  &:hover {
    transform: scale(1.05);
  }
`;


